export default __webpack_public_path__ + "static/media/201.c32c76ca.png";